export default {
  data() {
    return {
      timeoutID: null,
    };
  },
  methods: {
    debounce(fn, delay = 300, abort = false) {
      clearTimeout(this.timeoutID);

      if (abort) return;
      this.timeoutID = setTimeout(() => {
        fn.apply(this, arguments);
      }, delay);
    },
  },
};
